import { Lock } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface LockedAuditSectionProps {
  id: string
  labelKey: string
  onUpgrade: () => void
}

export function LockedAuditSection({ id, labelKey, onUpgrade }: LockedAuditSectionProps) {
  const { t } = useTranslation()

  return (
    <div
      id={id}
      className="rounded-2xl border-2 border-dashed border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-900/50 p-6 flex items-center justify-between gap-4"
    >
      <div className="flex items-center gap-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-neutral-200 dark:bg-neutral-800 text-neutral-400">
          <Lock className="h-4 w-4" aria-hidden="true" />
        </div>
        <div>
          <p className="text-sm font-semibold text-neutral-700 dark:text-neutral-300">
            {t(labelKey)}
          </p>
          <p className="text-xs text-neutral-400 dark:text-neutral-500 mt-0.5">
            {t('amazonAudit.lockedSection.available')}
          </p>
        </div>
      </div>
      <button
        onClick={onUpgrade}
        className="shrink-0 rounded-lg border border-primary-300 dark:border-primary-700 bg-primary-50 dark:bg-primary-900/30 px-3 py-1.5 text-xs font-semibold text-primary-600 dark:text-primary-400 hover:bg-primary-100 dark:hover:bg-primary-900/50 transition-colors"
      >
        {t('amazonAudit.lockedSection.cta')} →
      </button>
    </div>
  )
}
